namespace $.$$ {

	export class $shm_projects_image_viewer extends $.$shm_projects_image_viewer {

		expanded() {
			return this.showed()
		}

		viewer_content() {
			return this.content().length ? this.content() : [ this.Preview_image() ]
		}

		@ $mol_mem
		override image_escape_listener() {
			if( !this.showed() ) return null
			return new this.$.$shm_listener( 'keydown', ( event: KeyboardEvent )=> {
				if( event.key !== 'Escape' || event.defaultPrevented ) return
				event.preventDefault()
				this.image_dismiss()
			}, this.$.$mol_dom_context.document, { passive: false } )
		}

		@ $mol_action
		image_dismiss() {
			this.showed( false )
			this.opened_uri( '' )
		}

		@ $mol_action
		override image_toggle( next?: MouseEvent ) {
			if( next === undefined ) return null
			const target = next.target
			if( !( target instanceof HTMLImageElement ) ) return next
			next.preventDefault()
			next.stopPropagation()
			this.opened_uri( target.currentSrc || target.src )
			this.showed( true )
			return next
		}

		@ $mol_action
		override image_close( next?: MouseEvent ) {
			if( next === undefined ) return null
			this.image_dismiss()
			return next
		}

	}

}
